
const placeholderBase = { width: '100%', maxWidth: 220, height: 180, margin: '0 auto' };

function IllustrationRider() {
  return (
    <svg
      viewBox="0 0 200 180"
      style={placeholderBase}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect x="20" y="120" width="160" height="4" rx="2" fill="#E5E5E5" />
      <circle cx="50" cy="150" r="16" fill="#1A1A1A" opacity="0.15" />
      <circle cx="150" cy="150" r="16" fill="#1A1A1A" opacity="0.15" />
      <path
        d="M55 100 L95 50 L120 50 L100 100 Z"
        fill="var(--ingo-primary)"
        opacity="0.2"
      />
      <rect x="85" y="35" width="40" height="20" rx="4" fill="var(--ingo-primary)" />
      <circle cx="100" cy="32" r="8" fill="#1A1A1A" />
      <path
        d="M95 100 L100 60 L65 100"
        stroke="var(--ingo-primary)"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export { IllustrationRider };
